import React from "react";

import { useSelectedDevice } from "../../services/DeviceService/DevicesHooks";

import { useGlobalStore } from "../../services/GlobalStoreService/GlobalStoreHooks";

import DeviceGridItem from "./DeviceGridItem";
import InnerSpinner from '../Loading/InnerSpinner';

import "./DeviceGrid.scss";

export default function DeviceGrid(props) {
    const devices = props.devices !== undefined && Array.isArray(props.devices) ? props.devices : null;

    const [selectedDeviceData, selectionState, changeSelection] = useSelectedDevice();

    const [mode, setMode] = useGlobalStore("mode", "READ");

    if (devices === null) {
        return null;
    }

    if (
        props.loading
        // (props.totalCount !== undefined && props.totalCount === 0) ||
        // (props.totalCount === undefined && devices.length === 0)
    ) {
        return (
            <div className="device-grid-loading">
                <InnerSpinner />
            </div>
        );
    }

    if(!props.loading && props.totalCount !== undefined && props.totalCount === 0) {
        return (
            <div className="device-grid-error">
                <h2>No Devices found.</h2>

            </div>
        )
    }

    if (devices.length === 0 && (props.totalCount !== undefined && props.totalCount > 0)) {
        return (
            <div className="device-grid">
                <h2>No valid matches for selected parameters</h2>
            </div>
        );
    }

    const selectedDeviceCode = selectionState === "OK" ? selectedDeviceData.code : null;

    function clickDevice(device) {
        if (mode !== "EDIT") {
            changeSelection(device.code);
        } else {
            if(!selectedDeviceCode) {
                setMode("READ");
                changeSelection(device.code);
            }
        }
    }

    return (
        <div className="device-grid">
            {devices.map(device => (
                <DeviceGridItem
                    device={device}
                    key={device.code}
                    onClick={() => clickDevice(device)}
                    selected={selectedDeviceCode === device.code}
                />
            ))}
        </div>
    );
}
